<template>

  <div>
    <el-form :model="formData" label-width="180px" :rules="rules">
      <el-row>
      <el-form-item label="巡检记录表：" prop="star">
        <el-input v-model="formData.patrol_table_name" placeholder="巡检记录表" clearable disabled  style="width: 250px">
        </el-input>
      </el-form-item>
      <el-form-item label="创建日期：" prop="star">
        <el-input v-model="formData.create_time" placeholder="创建日期" clearable disabled  style="width: 250px">
        </el-input>
      </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="设备总数：" prop="star">
          <el-input v-model="formData.device_sum" placeholder="设备总数" clearable disabled  style="width: 250px">
          </el-input>
        </el-form-item>
        <el-form-item label="已巡检设备数：" prop="star">
          <el-input v-model="formData.finish_sum" placeholder="已巡检设备数" clearable disabled  style="width: 250px">
          </el-input>
        </el-form-item>
      </el-row>
      <el-row>
        <el-form-item label="异常要维修设备数：" prop="star">
          <el-input v-model="formData.error_sum" placeholder="异常要维修设备数" clearable disabled  style="width: 250px">
          </el-input>
        </el-form-item>
      </el-row>

      <span style="margin-left: 60px;font-size: 15px;font-weight: bold">巡检列表：</span>
      <div v-for="item in formData.recordItemList">
        <el-row>
          <el-form-item label="编号：" prop="star">
            <el-input v-model="item.device_no" placeholder="编号" clearable disabled  style="width: 250px">
            </el-input>
          </el-form-item>
          <el-form-item label="设备名称：" prop="star">
            <el-input v-model="item.name" placeholder="设备名称" clearable disabled  style="width: 250px">
            </el-input>
          </el-form-item>
          <el-form-item label="规格型号：" prop="star">
            <el-input v-model="item.model" placeholder="规格型号" clearable disabled  style="width: 250px">
            </el-input>
          </el-form-item>
          <el-form-item label="设备类型：" prop="star">
            <el-input v-model="item.type" placeholder="设备类型" clearable disabled  style="width: 250px">
            </el-input>
          </el-form-item>
        </el-row>
        <el-table :data="item.item_list" stripe border :header-cell-style="{textAlign: 'center',background:'lightgray',color:'black'}"
                  :cell-style="{ textAlign: 'center', width: '80%',}" style="width: 800px;margin-left: 60px">
          <el-table-column prop="index" label="序号" width="80" fixed>
            <template v-slot="scope">
              {{ scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column prop="checkName" label="巡检项目" />
          <el-table-column prop="resultText" label="结果" width="100"/>
        </el-table>
        <el-form-item></el-form-item>
        <div style="margin-left: 60px;font-size: 15px;font-weight: bold;">图片：</div>
        <el-row>
          <el-col :span="8" v-for="image_url in item.image_urls">
          <el-image :src="image_url" :preview-src-list="[image_url]"
                    :initial-index="0" fit="cover" preview-teleported="true" />
          </el-col>
        </el-row>
        <div style="margin-left: 60px;font-size: 15px;font-weight: bold;">备注文字：</div>
        <el-input v-model="item.remark" placeholder="备注"  :rows="4" type="textarea" disabled  style="width: 800px;margin-left: 60px;"></el-input>
      </div>
    </el-form>


  </div>
</template>

<script>

export default {
  name: "EqPatrolRecordZhiZaoDetails",
  props: {
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      formData: {

      },

      rules: {
        star: [{required: true, message: '', trigger: 'blur'}],
      },
    }
  },
  computed: {},
  methods: {
    getPatrolRecordData() {
       this.$http('eqPatrolRecordZhiZaoService.getPatrolRecord',this.parentData).then(data => {
         this.formData = data
      }, errMsg => {
        return this.$message.error('获取详情数据失败：' + errMsg);
      })
    },

  },
  created() {
     this.getPatrolRecordData()

  }
}
</script>

<style scoped>

</style>